import * as Yup from "yup";
import * as Schemas from "../../forms/validationSchemas.js";

export function resourceBlockValidationSchema(messages) {
  const volumesShape = {
    // volumeSize: Schemas.sliderSchema("Volume", messages),
    // volumeSize: Yup.mixed().when("image", {
    //   is: value => value !== null,
    //   then: Schemas.sliderSchema("Volume", messages)
    // }),
    // rootVolumeSize: Yup.mixed().when("image", {
    //   is: value => value !== null,
    //   then: Schemas.sliderSchema("Volume", messages)
    // }),
    // rootVolumeCount: Yup.mixed().when("rootVolumeSize", {
    //   is: value => value !== null,
    //   then: Schemas.sliderSchema("Volume", messages)
    // }),
    // dataVolumeSize: Yup.mixed().when("image", {
    //   is: value => value !== null,
    //   then: Schemas.sliderSchema("Volume", messages)
    // }),
    // dataVolumeCount: Yup.mixed().when("dataVolumeSize", {
    //   is: value => value !== null,
    //   then: Schemas.sliderSchema("Volume", messages)
    // })
  };

  return Yup.object().shape({
    namingScheme: Schemas.simpleStringSchema("Name", messages, false),
    name: Yup.string().when("namingScheme", {
      is: value => {
        return typeof value === "string";
      }, // if namingScheme exists we're using multiples
      then: Yup.string(), // we don't require name when multiples are in use
      otherwise: Schemas.simpleStringSchema("Name", messages, true)
    }),
    startAt: Yup.number().when("namingScheme", {
      is: value => typeof value === "string",
      then: schema => schema.required().min(0).integer(),
      otherwise: schema => schema.notRequired()
    }),
    size: Schemas.dropdownSchema("Size", messages, true),
    image: Schemas.dropdownSchema("Build profile", messages, true),
    ...volumesShape
  });
}
